export const HomePage = () => {
    return (
        <>
            <div className="content-layout">
                <h1 id="page-title" className="content__title">
                    Bienvenue sur la gestion des expéditions
                </h1>
                <div className="content__body">
                    <p id="page-description">
            <span>
              Cliquez sur un menu pour ouvrir la page souhaitée.
            </span>
                    </p>
                </div>
            </div>
        </>
    );
};
